import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import { useOpenClaudeSetup } from "./ClaudePrompt";

const ClaudeSetupButton: React.VFC = () => (
  <Tooltip title="Set up Claude to edit content for you">
    <Button size="small" onClick={useOpenClaudeSetup()} data-tour="hf-claude">
      🤖 Claude
    </Button>
  </Tooltip>
);

export default ClaudeSetupButton;
